<template>
    <div class="course-blocks" :class="{ 'cancelled': item.booking_item_state_id == 4 }">

        <div class="date-price top-dates">
            <i class="fa fa-calendar" id="updateCalender"></i>

            <span class="days-container" :class="{ 'full-width': !isRestorable && !editable }">
				<span v-html="dateString"></span>
			</span>
            <span class="venue">{{ item.venue_name }} ({{ item.venue_town }})</span>

            <a @click="restore(item.id)" class="fa" id="restoreCourse" v-if="isRestorable"><div :class="{ 'fa-history': !restoring, 'fa-refresh fa-spin': restoring }"></div></a>
            <a @click="remove(item.id)" class="fa red" id="removeCourse" v-else-if="editable"><div :class="{ 'fa-trash': !deleting, 'fa-spinner fa-pulse': deleting }"></div></a>
            <router-link :to="{ name: 'account.bookings.item.edit', params: { bookingId, bookingItemId: item.id } }" class="fa fa-pencil" id="editBookingItem" v-if="editable && !item.is_restorable"></router-link>

        </div>
        <div class="course-details">
            <span class="package">{{ item.package_name }}: {{ item.start_time }}-{{ item.end_time }}</span>
        </div>
        <!-- <div class="course-overall" :class="{ 'date-price': item.full_package_price == item.booking_item_total_cost || (!discounts.length && !fees.length)}">
            <b :class="{ 'discount': item.full_package_price != item.booking_item_total_cost && (discounts.length || fees.length) }">
                {{ currencyFormat((item.full_package_price != item.booking_item_total_cost && (!discounts.length && !fees.length) ? item.full_package_price : (item.package_price_type_readable == "Day" && $root.config.use_short_weeks ? parseFloat(item.full_package_price)*item.days_attending.length : item.full_package_price))) + (item.hasOwnProperty('package_price_type_readable') && item.package_price_type_readable == "Day" && !$root.config.use_short_weeks ? ' /' + item.package_price_type_readable.toLowerCase() : '') }}
            </b>
        </div> -->

        <div class="course-overall" :class="{ 'date-price': item.full_package_price == item.booking_item_total_cost || (!discounts.length && !fees.length)}">
            <b :class="{ 'discount': item.full_package_price != item.booking_item_total_cost && (discounts.length || fees.length) }">
                {{ currencyFormat(parseFloat(item.full_package_price)) }}
            </b>
        </div>

        <div class="date-price">

            <div class="discount-banner" v-if="fee != undefined" v-for="fee in fees">
                <span>{{ fee.description }}</span>

                <b class="amount">{{ currencyFormat(Math.abs(fee.fee_amount)) }}</b>
            </div>
            <div class="discount-banner" v-if="discount != undefined && discount.discount_amount > 0" v-for="discount in discounts">
                <span>{{ discount.description }}</span>

                <b class="amount">- {{ currencyFormat(Math.abs(discount.discount_amount)) }}</b>
            </div>
            <div class="discount-banner" v-if="item.full_package_price != item.booking_item_total_cost && (discounts.length || fees.length)">
                <span class="final-cost"> Price </span>
                <b>{{ currencyFormat(item.booking_item_total_cost) }}</b>
            </div>
        </div>
        <!-- Removing the option of upgrade as per request
            <div class="upgrade-block" v-if="upgrade != null && editable">
                <span>Upgrade to {{ upgrade.name }} for an extra {{ currencyFormat(upgrade.price_difference) }}</span>
                <button class="btn-primary disabled" v-if="upgrading">Upgrading <i class="fa fa-spinner fa-pulse"></i></button>
                <button class="btn btn-primary" @click="triggerUpgrade" v-else >Upgrade</button>
            </div>
        -->
    </div>
</template>

<script>
    export default {
        props: ['participant', 'item', 'bookingId'],

        data () {
            return {
                deleting: false,
                restoring: false,
                upgrading: false,
                town: "",

                originalPrice: 0,

                upgrade: null
            }
        },

        computed: {
            fees: function () {
                return Object.keys(this.item.fees).map(key => { return this.item.fees[key]; })
            },
            discounts: function () {
                return Object.keys(this.item.discounts).map(key => { return this.item.discounts[key]; })
            },
            editable: function () {
                return this.$parent.editable && this.item.is_deletable && !this.isRestorable;
            },
            isRestorable: function () {
                return this.$parent.editable && this.item.is_restorable;
            },
            dateString: function () {
                var start = new Date(this.item.days_attending[0]);
                // console.log('start', this.item.days_attending[0], start);
                if(this.item.days_attending.length > 1)
                    return start.formatRange(this.item.days_attending);
                else
                    return start.toDateString();
            }
        },

        methods: {
            remove: function ( item_id ) {
                this.deleting = true;
                axios.delete('/camp-booking/bookings/' + this.bookingId + '/items/' + item_id)
                    .then(response => {
                        this.deleting = false;
                        this.$emit('update');

                        //Notifying the user the item has been removed
                        if(response.data.data.deleted)
                            this.$root.alert(this.$parent.$parent.$parent.locale.text_item_remove_alert, 'success', 3000);
                    });
            },
            restore: function ( item_id ) {
                this.restoring = true;
                axios.put('/camp-booking/bookings/' + this.bookingId + '/items/' + item_id + '/restore')
                    .then(response => {
                        this.restoring = false;
                        this.$emit('update');

                        //Notifying the user the item has been removed
                        if(response.data.data)
                            this.$root.alert(this.$parent.$parent.$parent.locale.text_item_restore_alert, 'success', 3000);
                    });
            },
            triggerUpgrade: function () {
                if(this.upgrading == true) {
                    return;
                }

                this.upgrading = true;
                axios.put('/camp-booking/bookings/' + this.bookingId + '/items/' + this.item.id + '/swap', {
                    0: {
                        "package_id": this.upgrade.id,
                        "participant_id": this.item.participant_id,
                        "dates_attending": this.upgrade.price_per == 'day' ? this.item.days_attending : undefined
                    }
                }).then(response => {
                    this.$emit('update');
                    setTimeout(() => {
                        this.upgrading = false;
                    }, 750);

                })
            },
            currencyFormat: function ( value ) {
                return (this.participant.currency_unit || '£') + value.toFixed(2);
            },
        },

        mounted: function () {
            //Checking for any packages for the same venue id on the same venue week id
            axios.get('/camp-booking/packages', {
                params: {
                    price_per: this.item.package_price_type_id == 1 ? 'week' : 'day',
                    age: new Date(this.item.participant_dob).getAge(),
                    venue_week_id: this.item.venue_week_id,
                    venue_id: this.item.venue_id,
                    hide_internal: true
                }
            }).then(response => {
                let packages = response.data.data,
                    currentPackage = packages.filter(p => p.id == this.item.package_id)[0];

                //Filter out the current package and any package lower cost than the current package
                packages = packages.filter(p =>
                    p.id != this.item.package_id &&
                    p.name != this.item.package_name &&
                    p.price > this.item.full_package_price &&
                    p.estimated_base_package_template_id == currentPackage.estimated_base_package_template_id
                );
                //Sort packages highest price to lowest
                packages = packages.sort((p1, p2) => p1.price < p2.price ? -1 : 1);

                if(packages.length > 0) {
                    this.upgrade = packages[0];
                    this.upgrade.price_difference = this.upgrade.price - this.item.full_package_price;
                }
            })
        },

        watch: {
            'item': {
                handler: function (val, oldVal) {
//                    this.setPrices();
                },
                deep: true
            }
        },
    }
</script>



// WEBPACK FOOTER //
// BasketBookingItem.vue?38e5914c